export const TICKET_PURCHASE_STATUS = {
    UNSPECIFIED: 0,
    WAITING_FOR_PAYMENT: 1,
    PAID: 2,
    EXPIRED: 3,
    REFUNDED: 4,
    IN_PROCESS: 5,
    PAYMENT_FAILED: 6,
    PAYMENT_PROCESSING: 7,
} as const;

// Keep ticket purchase status labels in one place so attendee, refund, and member ticket views stay in sync.
export const getTicketPurchaseStatusLabelKey = (status?: number | string | null): string => {
    switch (Number(status)) {
        case TICKET_PURCHASE_STATUS.UNSPECIFIED:
            return 'ticket_purchase_status_labels.unspecified';
        case TICKET_PURCHASE_STATUS.WAITING_FOR_PAYMENT:
            return 'booking_status_labels.waiting_for_payment';
        case TICKET_PURCHASE_STATUS.PAID:
            return 'labels.paid';
        case TICKET_PURCHASE_STATUS.EXPIRED:
            return 'labels.expired';
        case TICKET_PURCHASE_STATUS.REFUNDED:
            return 'labels.refunded';
        case TICKET_PURCHASE_STATUS.IN_PROCESS:
            return 'ticket_purchase_status_labels.in_process';
        case TICKET_PURCHASE_STATUS.PAYMENT_FAILED:
            return 'ticket_purchase_status_labels.payment_failed';
        case TICKET_PURCHASE_STATUS.PAYMENT_PROCESSING:
            return 'ticket_purchase_status_labels.payment_processing';
        default:
            return 'labels.unknown';
    }
};
